<script>
import Multiselect from "vue-multiselect"

const DEFAULT_CONFIG_OPTIONS = {
  "track-by": "name",
  label: "name",
  placeholder: "Seleccionar un usuario",
  "show-no-results": false,
  searchable: true,
  "show-labels": false,
  "allow-empty": false
}

export default {
  props: {
    optionsList: {
      type: Array,
      required: true
    },
    config: {
      type: Object,
      required: false,
      default: () => {
        return new Object()
      }
    },
    value: {
      type: null,
      required: true
    }
  },
  components: {
    Multiselect
  },
  render(createElement) {
    let currentConfigOptions = {
      options: this.optionsList,
      value: this.value
    }
    if (Object.keys(this.config).length) {
      Object.keys(this.config).forEach(key => {
        DEFAULT_CONFIG_OPTIONS[key] = this.config[key]
      })
    }
    currentConfigOptions = { ...currentConfigOptions, ...DEFAULT_CONFIG_OPTIONS }

    return createElement("multiselect", {
      props: currentConfigOptions,
      domProps: {
        value: this.value
      },
      on: {
        select: event => {
          this.$emit("input", event)
        }
      }
    })
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect {
  min-height: 35px;
}

.multiselect__tags,
.multiselect__input,
.multiselect__single,
.multiselect__element {
  background-color: #f2f2f2;
}

.multiselect__tags {
  border: 1px solid #e0e0e0;
  min-height: 35px;
  padding: 5px 0px 0 8px;
}

.multiselect__input,
.multiselect__single {
  line-height: 15px;
}

.multiselect__input {
  min-width: 380px;
}

.multiselect__single {
  max-width: 90%;
  margin-top: 4px;
  margin-bottom: 4px;
}

.multiselect__select:before {
  top: 64%;
  color: black;
  border-color: black transparent transparent;
}

.multiselect__option--highlight {
  color: black;
  background-color: #e4e4e4;
}

.multiselect__option--selected.multiselect__option--highlight {
  background-color: #f2f2f2;
  color: black;
}
</style>
